module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/33823-e6b954798f2e77233e5e53b337d3b812.svg";